import { render, staticRenderFns } from "./postRiceContent.vue?vue&type=template&id=0971492e"
import script from "./postRiceContent.vue?vue&type=script&lang=js"
export * from "./postRiceContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports